import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  FormGroup, Label, Row, Col, Button, FormText,
} from 'reactstrap';
import { Field, formValueSelector } from 'redux-form';
import * as Actions from '../../actions/schoolEntryActions';
import {
  renderInput, required, Required, toNumber,
} from '../../helpers/formHelper';
import { FREE_TRIAL_PC_RENTAL_ID } from '../../helpers/helper';

class View extends PureComponent {
  componentDidMount() {
    this.props.setPcTypes(this.props.initialPcTypes);
    this.props.initialize();
  }

  getPcTypes() {
    const { pcTypes, isFreeTrial } = this.props;
    if (!isFreeTrial) {
      return pcTypes.filter((x) => x.id !== FREE_TRIAL_PC_RENTAL_ID);
    }
    return pcTypes;
  }

  render() {
    const {
      displays, formValues, courses, dayLocations, linkSvgPath, innovationStudioSelected,
    } = this.props;
    const pcRentalAvailable = () => this.getPcTypes().some((x) => x.id === FREE_TRIAL_PC_RENTAL_ID);
    return (
      <>
        <Field name="school_application[school_application_tag_id]" type="hidden" component="input" />
        <h2>クラス・コース情報</h2>
        <FormGroup>
          <Label>校舎</Label>
          <Required />
          <Field
            name="school_application[school_location_id]"
            type="select"
            component={renderInput}
            validate={[required]}
            id="school_application_school_location_id"
          >
            <option value="">お選びください</option>
            {displays.locations.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
          </Field>
        </FormGroup>
        <FormGroup>
          <Label>申込み曜日クラス</Label>
          <Required />
          <Field
            name="school_application[day_location_id]"
            type="select"
            component={renderInput}
            validate={[required]}
            id="school_application_day_location_id"
            disabled={dayLocations.length === 0}
          >
            <option value="">お選びください</option>
            {dayLocations.map((x) => <option key={x.id} value={x.id} disabled={x.disabled}>{x.name}</option>)}
          </Field>
          {innovationStudioSelected && (
            <FormText>
              選択されたイノベーションスタジオは、通常クラスとはカリキュラムや受講料等が異なるクラスとなります。
              <br />
              <a href="http://lit.sh/innovationstudio" target="_blank" rel="noopener noreferrer">イノベーションスタジオの詳細はこちら</a>
            </FormText>
          )}
          {formValues.school_application !== undefined
           && formValues.school_application.day_location_id !== undefined
           && formValues.school_application.day_location_id !== 'お選びください'
           && formValues.school_application.day_location_id !== '' && (
            ''
          // <FormText>初回入塾日はTODO: 初回入塾日になります。</FormText>
          )}
        </FormGroup>
        <FormGroup>
          <Label>参加コース</Label>
          <Required />
          <Field
            name="school_application[course_id]"
            type="select"
            component={renderInput}
            validate={[required]}
            id="school_application_course_id"
            disabled={courses.length === 0}
          >
            <option value="">お選びください</option>
            {courses.map((x) => <option key={x.id} value={x.id} disabled={x.disabled}>{x.name}</option>)}
          </Field>
          {formValues.school_application !== undefined
           // AIクリエイティブコースの場合
           && formValues.school_application.course_id === '29' && (
           <FormText>※AIクリエイティブコースでは、使用するツールの利用規約上、13歳以上の方がご参加可能です。13歳未満の方は、他コースをお選びください。</FormText>
          )}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="school_application[pc_type_id]">
            持ち込みPCの種類
            {pcRentalAvailable() && '（レンタル可）'}
          </Label>
          <Required />
          <Field
            name="school_application[pc_type_id]"
            type="select"
            component={renderInput}
            validate={[required]}
            parse={toNumber}
            id="school_application_pc_type_id"
          >
            <option>お選びください</option>
            {this.getPcTypes().map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
          </Field>
          {pcRentalAvailable() ? (
            <>
              <Label className="d-block mb-0" style={{ marginTop: '10px' }}>ご自身のPCを使用される方へ</Label>
              <Row className="justify-content-center">
                <Col xs={12} sm={8}>
                  <p className="mb-0">
                    ご自身のPCが必要スペックを満たしていることを必ずご確認ください。
                    <br />
                    また、ご自身のPCを使用される場合、事前設定はお客さまご自身に行っていただきます。
                  </p>
                </Col>
                <Col xs={6} sm={4} className="mx-auto p-0">
                  <Button
                    className="information-for-pc"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://docs.life-is-tech.com/pc-setting');
                    }}
                  >
                    必要スペックはこちら
                    <img src={linkSvgPath} height="12" width="12" alt=">>" />
                  </Button>
                </Col>
              </Row>
              <FormText color="danger" style={{ marginTop: '10px' }}>
                PCをレンタルされる方へ
                <br />
                スクールのPCレンタルは無料体験期間中のみ可能です。
                <br />
                体験期間終了後は必ずご自身のPCのご用意が必要となりますので、あらかじめご了承ください。
              </FormText>
            </>
          ) : (
            <FormText color="danger" style={{ marginTop: '10px' }}>
              スクールではPCレンタルはございません。必ず
              <a href="https://docs.life-is-tech.com/pc-setting" target="_blank" rel="noopener noreferrer">こちら</a>
              で必要スペックを確認し、ご自身のPCをご準備ください。
            </FormText>
          )}
        </FormGroup>
      </>
    );
  }
}

View.propTypes = {
  displays: PropTypes.shape({
    locations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })).isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
  }).isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    disabled: PropTypes.bool,
  })).isRequired,
  dayLocations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    disabled: PropTypes.bool,
  })).isRequired,
  pcTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
  linkSvgPath: PropTypes.string.isRequired,
  isFreeTrial: PropTypes.bool.isRequired,
  initialize: PropTypes.func.isRequired,
  initialPcTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
  setPcTypes: PropTypes.func.isRequired,
  innovationStudioSelected: PropTypes.bool.isRequired,
};

const selector = formValueSelector('schoolEntryIndex');
export default connect((state) => ({
  formValues: selector(
    state,
    'authenticity_token',
    'school_application',
  ),
  courses: state.schoolEntry.courses,
  dayLocations: state.schoolEntry.dayLocations,
  pcTypes: state.schoolEntry.pcTypes,
  isFreeTrial: state.schoolEntry.isFreeTrial,
  innovationStudioSelected: state.schoolEntry.innovationStudioSelected,
}), (dispatch) => ({
  initialize: (payload) => dispatch({
    type: Actions.SAGA_INITIALIZE,
    payload,
  }),
  setPcTypes: (payload) => dispatch(Actions.setPcTypes(payload)),
}))(View);
